<template>
  <div class="main-report">
    <div class="dates-section">
      <div class="date-picker">
        <date-picker
          lang="en"
          placeholder="Start date"
          :disabled-date="notAfterToday"
          v-model="startDate"
          input-class="form-control"
        ></date-picker>
      </div>
      <div class="date-picker">
        <date-picker
          lang="en"
          placeholder="End date"
          :disabled-date="notAfterToday"
          v-model="endDate"
          input-class="form-control"
        ></date-picker>
      </div>
      <button class="generating" @click="getDepRegForChartReport()"><i class="far fa-window-restore"></i> </button>

    </div>
    <div class="btn-group">
      <button class="format-btn" @click="getDepRegForChartReport()">
        Get Report
      </button>
    </div>
    <div class="report-range">
      Report Range: {{ formatDate(startDate) }} -
      {{ formatDate(endDate) }}
    </div>
    <div v-if="!Array.isArray(report.length) > 0 && !reportBusy">
      <span class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="REG"
            value="REG"
            checked
          />
          <label class="filter-title" for="REG">REG</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="DUP"
            value="DUP"
          />
          <label class="filter-title" for="DUP">DUP</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="ALL"
            value="ALL"
          />
          <label class="filter-title" for="ALL">ALL</label>
        </div>
      </span>
      <span class="deposits-title"
        >Deposits: {{ report[filterOption].deposits }}</span
      >
      <div class="data-tables">
        <div class="data-table">
          <span class="table-title"
            >Amount: {{ report[filterOption]["campaigns"].amount }}</span
          >
          <table>
            <tr>
              <th>Campaign</th>
              <th>AMT</th>
            </tr>
            <tr
              v-for="(data, index) in report[filterOption]['campaigns'][
                'campaigns'
              ]"
              :key="index"
            >
              <td>{{ index }}</td>
              <td>{{ data }}</td>
            </tr>
          </table>
        </div>
        <div class="data-table">
          <span class="table-title"
            >Amount: {{ report[filterOption]["devices"].amount }}</span
          >
          <table>
            <tr>
              <th>Device</th>
              <th>AMT</th>
            </tr>
            <tr
              v-for="(data, index) in report[filterOption]['devices'][
                'devices'
              ]"
              :key="index"
            >
              <td>{{ index }}</td>
              <td>{{ data }}</td>
            </tr>
          </table>
        </div>
        <div class="data-table">
          <span class="table-title"
            >Amount: {{ report[filterOption]["users"].amount }}</span
          >
          <table>
            <tr>
              <th>User</th>
              <th>AMT</th>
            </tr>
            <tr
              v-for="(data, index) in report[filterOption]['users']['users']"
              :key="index"
            >
              <td>
                {{
                  salesPersonList.find(item => item.id === Number(index))
                    .full_name
                }}
              </td>
              <td>{{ data }}</td>
            </tr>
          </table>
        </div>
        <div class="data-table">
          <span class="table-title"
            >Amount: {{ report[filterOption]["tiers"].amount }}</span
          >
          <table>
            <tr>
              <th>Tier</th>
              <th>AMT</th>
            </tr>
            <tr
              v-for="(data, index) in report[filterOption]['tiers']['tiers']"
              :key="index"
            >
              <td>
                {{ index }}
              </td>
              <td>{{ data }}</td>
            </tr>
          </table>
        </div>
        <div class="data-table">
          <span class="table-title"
            >Amount: {{ report[filterOption]["registrations"].amount }}| CR:
            {{ report[filterOption]["registrations"].CR }}</span
          >
          <table>
            <tr>
              <th>Registration Date</th>
              <th>AMT</th>
            </tr>
            <tr
              v-for="(data, index) in report[filterOption]['registrations'][
                'registration_dates'
              ]"
              :key="index"
            >
              <td>
                {{ index }}
              </td>
              <td>{{ data }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="loader-div" v-if="reportBusy">
      <!--      <loader :size="'8px'"></loader>-->
      <span class="insteadLoader"
        >CREATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import Loader from "../../../../../main/misc.main/loader/Loader";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  name: "DepositVSRegistrationReportChart.container",
  components: {
    /*  Loader,*/
    DatePicker
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      report: [],
      reportBusy: false,
      filterOption: "REG",
      endDate: moment().format("YYYY-MM-DD"),
      startDate: moment()
        .subtract(2, "months")
        .format("YYYY-MM-DD")
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.getDepRegForChartReport();
  },
  methods: {
    async getDepRegForChartReport() {
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/deposits/registration/vs?from_date=${this.formatDate(
              this.startDate
            )}&to_date=${this.formatDate(this.endDate)}`
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    notAfterToday(date) {
      return date > moment();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>

<style scoped>
table tr:nth-of-type(2n + 1) {
  background: #f5f7ff;
}
table tr:hover {
  background: #eceff1;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.4em;
}
th {
  font-size: smaller;
}
.main-report {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5em 0;
  flex-direction: column;
}
.filter-buttons {
  padding: 1em 0;
}
.btn-group {
  padding: 1em 0;
}
.format-btn {
  margin: 0 1em;
}
.dates-section {
  display: flex;
}
.date-picker {
  margin: 0 1em;
}
.report-range {
  font-weight: bold;
  padding-top: 1em;
}
.data-tables {
  display: flex;
  align-items: baseline;
}
.data-table {
  padding: 0 2em;
}
.table-title {
  padding: 1em 0;
  font-weight: bold;
  display: flex;
}
.deposits-title {
  display: flex;
  justify-content: center;
  font-weight: bold;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 35%;
  top: 158px;
}
</style>
